<ul class="mb-0 ps-0 mx-3">
    @for(occurrence of occurrences; track $index){
        @if($index < 4){
            <poll-task-details-occurrence [occurrence]="occurrence"
                                            [isSelected]="occurrence.pollOccurrenceId === selectedOccurrence?.pollOccurrenceId"
                                            [pollFrequency]="pollFrequency"
                                            (onSelectOccurence)="onSelect($event)"></poll-task-details-occurrence>
        }                         
    }
    @if(occurrences.length > 4){
        @if(!showAll){
            <span class="text-link" (click)="showAll = true" >
                <small>{{occurrences.length - 4}} {{'polls_settings.show_more' | translate}}</small>
            </span>
        }@else{
            @for(occurrence of occurrences; track $index){
                @if($index >= 4){
                    <poll-task-details-occurrence [occurrence]="occurrence"
                                                  [isSelected]="occurrence.pollOccurrenceId === selectedOccurrence?.pollOccurrenceId"
                                                  [pollFrequency]="pollFrequency"
                                                  (onSelectOccurence)="onSelect($event)"></poll-task-details-occurrence>
                }                         
            }
            <div class="text-link text-center" (click)="showAll = false">
                <small><i class="fa-solid fa-chevron-up pe-1"></i>{{'polls_settings.show_less' | translate}}</small>
            </div>
        }
    }                         
</ul>


